import { render, staticRenderFns } from "./sellerInput.vue?vue&type=template&id=0b7af7fe&"
import script from "./sellerInput.vue?vue&type=script&lang=js&"
export * from "./sellerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports